import { push } from 'react-router-redux';
import Cookies from 'js-cookie';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';


////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// GET
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetPost = packet => {
  return {
    type: 'REQUEST_GET_POST',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetPostSuccess = data => ({
  type: 'RECEIVE_GET_POST_SUCCESS',
  data
})

export const receiveGetPostFail = data => ({
  type: 'RECEIVE_GET_POST_FAIL',
  data
})

export const tryToGetPost = packet => (dispatch, getState) => {

  dispatch(requestGetPost(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/posts/' + packet.slug, 
    {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetPostSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetPostFail({errors:e, lastSubmit: packet}));
      dispatch(push('/oops'))
    })
}
